/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { AuthUser } from '../types/User';
import { Lang } from '../assets/lang/lang';

export class LocStorageService {
	public loadUserFromStorage(): AuthUser {
		const savedUser = localStorage.getItem('user');
		if (!!savedUser) {
			return this.parseLocStorageItemToJson(savedUser);
		} else {
			return {
				token: '',
				id: '',
				username: '',
				imgUrl: '',
			};
		}
	}

	public saveUserToStorage(user: AuthUser): void {
		localStorage.setItem('user', this.parseAuthUserToLocStorageItem(user));
	}

	private parseAuthUserToLocStorageItem(user: AuthUser): string {
		return JSON.stringify(user);
	}

	private parseLocStorageItemToJson(user: string): AuthUser {
		return JSON.parse(user);
	}

	public getLanguage(): Lang | null {
		if (!localStorage.getItem('lang')) {
			return null;
		}

		if (localStorage.getItem('lang') === Lang.GERMAN) {
			return Lang.GERMAN;
		} else {
			return Lang.ENGLISH;
		}
	}

	public changeLanguage(language: Lang): void {
		localStorage.setItem('lang', language);
	}
}
